import httpMethods from '../../helpers/http-methods'
import axios from '../liverig-axios.service'

export const liverigResource = httpMethods(axios)
